import { BulkSpreadsheet, parseInt10, type BulkColumn } from '../shared/BulkSpreadsheet';
import { categoryService } from '@kss/api';
import type { CategoryCreate } from '@kss/api';
import { loadCategoryOptions, loadStoreOptions } from '../shared/formLoaders';

const columns: BulkColumn<CategoryCreate>[] = [
  { key: 'name', header: 'Name', required: true, sample: 'Beverages' },
  { key: 'description', header: 'Description', sample: 'Drinks & mixes' },
  {
    key: 'sortOrder',
    header: 'Sort order',
    dataType: 'integer',
    parse: parseInt10 as (v: string) => CategoryCreate['sortOrder'],
    sample: '10',
  },
  {
    key: 'parentId',
    header: 'Parent category',
    dataType: 'lookup',
    loadOptions: loadCategoryOptions,
    sample: '',
  },
  {
    key: 'storeId',
    header: 'Store',
    dataType: 'lookup',
    loadOptions: loadStoreOptions,
    sample: '',
  },
  {
    key: 'isActive',
    header: 'Active',
    dataType: 'boolean',
    parse: (v) => {
      const s = v.trim().toLowerCase();
      if (['', '1', 'true', 'yes', 'y', 'active'].includes(s)) return true as CategoryCreate['isActive'];
      if (['0', 'false', 'no', 'n', 'inactive'].includes(s)) return false as CategoryCreate['isActive'];
      return true as CategoryCreate['isActive'];
    },
    sample: 'true',
  },
];

export default function BulkCategory() {
  return (
    <BulkSpreadsheet<CategoryCreate>
      title="Bulk import categories"
      entityLabel="category"
      backPath="/panel/categories"
      module="Category"
      columns={columns}
      onImport={async (rows) => {
        const payload = rows.map((r) => ({ ...r, isActive: r.isActive ?? true }));
        const created = await categoryService.create(payload);
        return { created: Array.isArray(created) ? created.length : payload.length };
      }}
    />
  );
}
